/* Recently viewed (stoklink-recently-viewed): product handles in
   localStorage, rows fetched from the stoklink-recent-row section. */
(function () {
  'use strict';

  var KEY = 'stoklink:recent';
  var fold = document.querySelector('[data-recent]');
  if (!fold) return;

  var current = fold.getAttribute('data-recent-handle') || '';
  var limit = parseInt(fold.getAttribute('data-recent-limit'), 10) || 6;
  var root = (fold.getAttribute('data-recent-root') || '/').replace(/\/$/, '');
  var sectionId = fold.getAttribute('data-recent-section');
  var rows = fold.querySelector('[data-recent-rows]');

  function read() {
    try {
      var list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(list)) return [];
      return list.filter(function (handle) { return typeof handle === 'string' && handle !== ''; });
    } catch (error) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (error) {
      /* storage blocked or full: the fold simply stays empty next time */
    }
  }

  var others = read().filter(function (handle) { return handle !== current; });
  if (current) write([current].concat(others).slice(0, 12));

  var wanted = others.slice(0, limit);
  if (!wanted.length || !rows || !sectionId) return;

  function fetchRow(handle) {
    var url = root + '/products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(sectionId);
    return window.fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var row = doc.querySelector('.product__row');
        return row ? document.adoptNode(row) : null;
      })
      .catch(function () { return null; });
  }

  var desktop = window.matchMedia('(min-width: 1024px)');
  function syncOpen() {
    fold.open = desktop.matches;
  }

  Promise.all(wanted.map(fetchRow)).then(function (nodes) {
    var kept = [];
    nodes.forEach(function (node, index) {
      if (!node) return;
      rows.appendChild(node);
      kept.push(wanted[index]);
    });
    if (kept.length < wanted.length) {
      write(read().filter(function (handle) { return wanted.indexOf(handle) === -1 || kept.indexOf(handle) !== -1; }));
    }
    if (!kept.length) return;
    syncOpen();
    desktop.addEventListener('change', syncOpen);
    fold.hidden = false;
  });
})();
